export const getters = {
  helpdeskSiteInfo: (state) => state.helpdesk_site_info,
};
